/**
 * 使得数据区间落在 0 - 100 之间
 * @param score
 * @returns
 */
export function regularize(score: number) {
    if (score < 0) {
        return 30 + 30 * (2 / (1 + Math.exp(-0.001 * score)) - 1);
    } else {
        return 30 + 70 * (2 / (1 + Math.exp(-0.001 * score)) - 1);
    }
}

/**
 * 将数字转为百分数
 * @param num
 * @returns
 */
export function formatPercentNumber(num: number): string {
    return isNaN(num) ? '-' : (num * 100).toFixed(2) + '%';
}

/**
 * 生成随机数
 * @param length 随机数长度
 * @returns
 */
export function createRandomNumber(length: number = 8) {
    return Math.floor(Math.random() * Math.pow(10, length));
}

/**
 * 保留几位小数
 */
export function roundNumber(number: number, digit = 2) {
    return Number(number.toFixed(digit));
}

/**
 * 添加正负号
 */
export function addSign(number: number): string {
    const str = String(number);
    return (number >= 0 ? '+' : '') + str;
}

/**
 * 生成标准的棋谱分数
 * @param number 
 * @returns 
 */
export function formatInScore(number: number): string {
    return (number >= 0 ? '+' : '') + number.toFixed(2);
}

/**
 * 将值调整进值域范围内
 * @param number 设置的数值
 * @param range 值域
 */
export function setInRange(number: number, range: Readonly<[number, number]>) {
    const [ min, max ] = range;
    return number < min ? min : number > max ? max : number;
}